import React from 'react';
import { useSelector } from 'react-redux';
import { SERVICE_INTEGRATION_MODE_MAIN } from '@utils/constants';
import { modeSelector } from '@store/serviceIntegrations/base/selectors';
import MainView from './MainView';
import FormView from './FormView';
import { ConfigWrapper } from './styled';

const ServiceIntegrationsPage = () => {
  const mode = useSelector(modeSelector);
  return (
    <ConfigWrapper>
      {
        mode === SERVICE_INTEGRATION_MODE_MAIN
          ? <MainView />
          : <FormView />
      }
    </ConfigWrapper>
  );
};

export default ServiceIntegrationsPage;
